// PRE RMA — Partage d'un texte de rapport (RSH, MNT/MTN). RIEN n'est envoyé automatiquement : chaque fonction est appelée par un clic
// de l'utilisateur, qui choisit lui-même le destinataire dans WhatsApp / SMS / la messagerie de son téléphone.
// Ordre de repli : feuille de partage Android/iOS (navigator.share) → lien WhatsApp → SMS → copie dans le presse-papiers.

export const partageNatifDisponible = (): boolean => typeof navigator !== 'undefined' && typeof navigator.share === 'function';

/** Feuille de partage du système (WhatsApp, SMS, e-mail… au choix de l'utilisateur). false si indisponible ou annulée. */
export async function partagerNatif(texte: string, titre: string): Promise<boolean> {
  if (!partageNatifDisponible()) return false;
  try { await navigator.share({ title: titre, text: texte }); return true; }
  catch { return false; /* annulé par l'utilisateur ou refusé : on ne l'enregistre pas comme une erreur */ }
}

/** Ouvre WhatsApp (application ou WhatsApp Web) avec le texte prérempli ; l'utilisateur choisit le destinataire puis envoie. */
export function ouvrirWhatsApp(texte: string): void {
  window.open(`https://wa.me/?text=${encodeURIComponent(texte)}`, '_blank', 'noopener,noreferrer');
}

/** Ouvre l'application SMS avec le texte prérempli (Android : « sms:?body= »). */
export function ouvrirSms(texte: string): void {
  window.location.href = `sms:?&body=${encodeURIComponent(texte)}`;
}

/** Copie le texte. Repli sur une zone de texte temporaire quand l'API presse-papiers est refusée (HTTP, anciens navigateurs). */
export async function copierTexte(texte: string): Promise<boolean> {
  try { await navigator.clipboard.writeText(texte); return true; } catch { /* repli ci-dessous */ }
  try {
    const zone = document.createElement('textarea');
    zone.value = texte; zone.setAttribute('readonly', ''); zone.style.position = 'fixed'; zone.style.opacity = '0';
    document.body.appendChild(zone); zone.select();
    const ok = document.execCommand('copy');
    zone.remove();
    return ok;
  } catch { return false; }
}
